import type React from 'react'
import { IN_PERSON_VISIT, ONLINE_VISIT, PHONE_VISIT, VIDEO_VISIT } from './constants'
import { VisitMethods } from '../constants/VisitMethods'
import phoneSvg from '../images/common/phone.svg'
import hospitalSvg from '../images/common/hospital.svg'
import cameraSvg from '../images/common/camera.svg'
import clipboardCheckSvg from '../images/common/clipboard-check.svg'

const style: React.CSSProperties = { width: 20, height: 20, alignSelf: 'center' }

const inPersonIconProps = {
  src: hospitalSvg,
  alt: IN_PERSON_VISIT,
  style,
}
const videoIconProps = {
  src: cameraSvg,
  alt: VIDEO_VISIT,
  style,
}
const callIconProps = {
  src: phoneSvg,
  alt: PHONE_VISIT,
  style,
}
const onlineIconProps = {
  src: clipboardCheckSvg,
  alt: ONLINE_VISIT,
  style,
}

export const getVisitTypeIconProps = (visitType: VisitMethods) => {
  switch (visitType) {
    case VisitMethods.INPERSON:
      return inPersonIconProps
    case VisitMethods.VIDEO:
      return videoIconProps
    case VisitMethods.CALL:
      return callIconProps
    case VisitMethods.ASYNCHRONOUS:
      return onlineIconProps
    default:
      return callIconProps
  }
}
